import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

const LINKS = [
  { to: "/", label: "Events", end: true, id: "events" },
  { to: "/the-bourbon-king", label: "The Story", id: "story" },
  { to: "/bourbon-clubs", label: "Clubs", id: "clubs" },
  { to: "/booking", label: "My booking", id: "find-booking" },
];

const linkCls = ({ isActive }) =>
  `whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.18em] transition-colors duration-200 ${isActive ? "text-[#D9B864]" : "text-[#E9E1D4] hover:text-[#D9B864]"}`;

const mobileCls = ({ isActive }) =>
  `block border-b border-white/10 py-4 font-display text-2xl transition-colors ${isActive ? "text-[#D9B864]" : "text-white"}`;

const BookNow = ({ className = "", onClick, id }) => (
  <Link to="/events/great-bourbon-heist#book" onClick={onClick} data-testid={id}
    className={`rounded bg-[#C9A24B] px-4 py-2.5 text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#141210] transition-colors hover:bg-[#D9B864] ${className}`}>Book now</Link>
);

const MobileMenu = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button type="button" className="flex h-10 w-10 items-center justify-center rounded border border-white/20 text-white md:hidden" aria-label="Open menu" data-testid="mobile-menu-button">
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[82%] border-l-0 bg-[#141210] text-white" data-testid="mobile-menu">
        <SheetTitle className="sr-only">Menu</SheetTitle>
        <nav className="mt-10">
          {LINKS.map((l) => <NavLink key={l.id} to={l.to} end={l.end} onClick={close} className={mobileCls} data-testid={`mobile-nav-${l.id}-link`}>{l.label}</NavLink>)}
        </nav>
        <BookNow className="mt-8 block py-4" onClick={close} id="mobile-book-now-button" />
        <a href="tel:+15027830430" className="mt-6 block text-center text-sm text-[#BDB3A5]" data-testid="mobile-menu-phone">(502) 783-0430</a>
      </SheetContent>
    </Sheet>
  );
};

export const SiteHeader = () => (
  <header className="sticky top-0 z-50 bg-[#141210] shadow-[0_4px_20px_rgba(0,0,0,0.25)] print:hidden" data-testid="site-header">
    <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-8 md:py-4">
      <Link to="/" className="flex items-center gap-3" data-testid="header-home-link">
        <img src="/images/bourbon-king-logo.png" alt="The Bourbon King" className="h-10 w-10 rounded-full object-cover" data-testid="header-logo" />
        <span className="leading-tight">
          <span className="block whitespace-nowrap font-display text-lg font-bold leading-none text-white sm:text-xl">The Bourbon <em className="text-[#D9B864]">King</em></span>
          <span className="mt-1 block text-[9px] font-bold uppercase tracking-[0.25em] text-[#BDB3A5]">Bourbon King™ Enterprises</span>
        </span>
      </Link>
      <nav className="hidden items-center gap-8 md:flex">
        {LINKS.map((l) => <NavLink key={l.id} to={l.to} end={l.end} className={linkCls} data-testid={`nav-${l.id}-link`}>{l.label}</NavLink>)}
        <BookNow id="nav-book-now-button" />
      </nav>
      <MobileMenu />
    </div>
  </header>
);
